import React, { ReactNode } from 'react';
import styles from './Heading.module.scss';
import classNames from 'classnames';

interface HeadingProps {
	title?: string;
	subHeading?: string;
	icon?: ReactNode;
	titleClassName?: string;
	subTitleClassName?: string;
	astrix?: boolean;
}

const Heading: React.FC<HeadingProps> = ({
	title,
	subHeading,
	icon,
	titleClassName,
	subTitleClassName,
	astrix
}) => {
	return (
		<div className={styles.root}>
			{title && (
				<div className={styles.heading}>
					{icon}
					<div className={classNames(titleClassName, styles.title)}>
						{title} {astrix && <span>*</span>}
					</div>
				</div>
			)}
			{subHeading && (
				<div
					className={classNames(subTitleClassName, styles.subHeading)}
				>
					{subHeading}
				</div>
			)}
		</div>
	);
};

export default Heading;
